import { FORMATION_ORDER } from "../config/constants.ts";
import type { FormationId } from "../utils/types.ts";

export interface VisualTestStep {
  id: string;
  label: string;
  durationMs: number;
}

export const VISUAL_TEST_STEPS: VisualTestStep[] = [
  { id: "galaxy", label: "VISUAL TEST · DEFAULT GALAXY", durationMs: 2500 },
  { id: "orbit", label: "VISUAL TEST · ORBIT", durationMs: 2500 },
  { id: "gravity", label: "VISUAL TEST · GRAVITY", durationMs: 2000 },
  { id: "supernova", label: "VISUAL TEST · SUPERNOVA", durationMs: 2200 },
  { id: "expand", label: "VISUAL TEST · COSMIC EXPANSION", durationMs: 2200 },
  { id: "black-hole", label: "VISUAL TEST · BLACK HOLE", durationMs: 2500 },
  { id: "formations", label: "VISUAL TEST · FORMATIONS", durationMs: 7000 },
];

export class VisualTestMode {
  private active = false;
  private startedAt = 0;
  private formationIndex = 0;

  start(): void {
    this.active = true;
    this.startedAt = performance.now();
    this.formationIndex = 0;
  }

  stop(): void {
    this.active = false;
  }

  isActive(): boolean {
    return this.active;
  }

  current(now = performance.now()): VisualTestStep | null {
    if (!this.active) return null;
    let t = now - this.startedAt;
    for (const step of VISUAL_TEST_STEPS) {
      if (t < step.durationMs) return step;
      t -= step.durationMs;
    }
    this.active = false;
    return null;
  }

  nextFormation(): FormationId {
    const id = FORMATION_ORDER[this.formationIndex % FORMATION_ORDER.length]!;
    this.formationIndex += 1;
    return id;
  }
}
